import React from 'react';
import { useIntl, defineMessages } from 'react-intl';
import { makeStyles, Theme } from '@lifeomic/chroma-react/styles';
import { Star } from '@lifeomic/chromicons';
import { IconButton } from '@lifeomic/chroma-react/components/IconButton';
import { useABAC } from '../../../../hooks';
import { useFavorite } from './useFavorite';
import clsx from 'clsx';

const messages = defineMessages({
  addFavorite: {
    id: 'SubjectViewer.Favorite.addFavorite',
    defaultMessage: 'Add favorite',
  },
  deleteFavorite: {
    id: 'SubjectViewer.Favorite.deleteFavorite',
    defaultMessage: 'Delete favorite',
  },
});

export const useStyles = makeStyles((theme: Theme) => ({
  root: {},
  favoriteIcon: {
    '&:hover': {
      transform: 'scale(1.2)',
      transition: 'transform 0.25s ease-in-out',
    },
  },
  favoritedTrial: {
    '& svg': {
      stroke: theme.palette.yellow.main,
    },

    '& svg path': {
      fill: theme.palette.yellow.main,
    },
  },
}));

export type FavoriteOwnProps = {
  resource: fhir.DomainResource;
  disabled?: boolean;
  onFavoriteUpdate?: (resource: fhir.DomainResource) => void;
  removeFavorite?: (resource: fhir.DomainResource) => fhir.DomainResource;
  addFavorite?: (resource: fhir.DomainResource) => fhir.DomainResource;
  isFavorite?: (resource: fhir.DomainResource) => boolean;
};

export type FavoriteProps = FavoriteOwnProps;

const Favorite: React.FC<FavoriteProps> = props => {
  const { formatMessage } = useIntl();
  const [canPerform, permissions] = useABAC();
  const classes = useStyles({});
  const { onFavorite, onUnfavorite, isFavorite } = useFavorite(props);

  const canUpdate = canPerform(permissions.updateData);

  return (
    <IconButton
      aria-label={formatMessage(
        isFavorite ? messages.deleteFavorite : messages.addFavorite,
      )}
      icon={Star}
      disabled={!canUpdate || props.disabled}
      className={clsx(
        classes.favoriteIcon,
        isFavorite && classes.favoritedTrial,
      )}
      onClick={isFavorite ? onUnfavorite : onFavorite}
      size={0}
    />
  );
};

export default React.memo(Favorite);
